import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "So my team does… what, exactly?",
    a: "Forwards an email, then taps approve. Brim's agents parse the carrier's PDF, audit it against P-pages, OEM procedures and DEG precedent, draft each cited response, queue follow-ups, and reconcile payment — with every outbound message approved by you and sent under your shop's name.",
  },
  {
    q: "Who actually sends the responses?",
    a: "You do. Agents do the research and the writing. You read it and approve it. It goes out under your shop's name, and nothing leaves Brim until you approve it.",
  },
  {
    q: "Is this public adjusting or legal representation?",
    a: "No. Brim is software. It drafts and tracks the supplement work your shop already does. Your shop reviews, approves and submits everything in its own name. Brim does not represent you, does not communicate with insurers on your behalf, and does not provide legal advice.",
  },
  {
    q: "Will this damage my DRP relationships?",
    a: "Brim argues exclusively from the record — the carrier's own estimating guide, OEM procedures, and public DEG precedent — in professional, documented correspondence. It removes the personal friction between your estimator and the adjuster entirely.",
  },
  {
    q: "What if the carrier stonewalls?",
    a: "Every exchange is logged into an organized, time-stamped record. When a carrier won't move, you can hand the complete documented file to your appraiser or attorney — already cited and ready. Delay stops being free.",
  },
  {
    q: "Which estimating systems do you cover?",
    a: "All three information providers — CCC/MOTOR, Mitchell, and Audatex. Agents cite the P-pages from the system the claim was written in, so the adjuster is answering their own guide.",
  },
];

const Faq = () => (
  <section
    data-testid="faq-section"
    className="py-20 sm:py-28 bg-white border-b border-[#E7E5E4]"
  >
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <div className="mb-10">
        <span className="text-xs font-bold uppercase tracking-widest text-[#9A3412]">
          FAQ
        </span>
        <h2 className="text-3xl sm:text-4xl font-normal text-stone-900 font-serif-display mt-2">
          Questions shops actually ask.
        </h2>
      </div>
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`item-${i}`}
            data-testid={`faq-item-${i + 1}`}
            className="border-stone-200"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i + 1}`}
              className="text-left text-sm sm:text-base font-bold text-stone-900 hover:text-[#9A3412] hover:no-underline"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-stone-600 leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default Faq;
